var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9932 9.45813H1.52301C0.718482 9.45813 0.0664062 8.80605 0.0664062 8.00153C0.0664062 7.197 0.718482 6.54492 1.52301 6.54492H4.9932C5.79773 6.54492 6.4498 7.197 6.4498 8.00153C6.4498 8.80605 5.79773 9.45813 4.9932 9.45813Z",
    fill: "#080A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4502 9.45813H10.98C10.1755 9.45813 9.52344 8.80605 9.52344 8.00153C9.52344 7.197 10.1755 6.54492 10.98 6.54492H14.4502C15.2548 6.54492 15.9068 7.197 15.9068 8.00153C15.9068 8.80605 15.2548 9.45813 14.4502 9.45813Z",
    fill: "#3FBEB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06598 6.39849C7.26145 6.39849 6.60938 5.74642 6.60938 4.94189V1.4566C6.60938 0.652075 7.26145 0 8.06598 0C8.87051 0 9.52258 0.652075 9.52258 1.4566V4.94038C9.52258 5.74491 8.87051 6.39698 8.06598 6.39698",
    fill: "#019497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06598 16.0001C7.26145 16.0001 6.60938 15.348 6.60938 14.5435V11.0567C6.60938 10.2522 7.26145 9.6001 8.06598 9.6001C8.87051 9.6001 9.52258 10.2522 9.52258 11.0567V14.5435C9.52258 15.348 8.87051 16.0001 8.06598 16.0001Z",
    fill: "#EF4873"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8415,
    height: 16,
    fill: "white",
    transform: "translate(0.0664062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpFavicon);
export default __webpack_public_path__ + "static/media/np-favicon.8f09a2a944004e1b917af28e37e9e70a.svg";
export { ForwardRef as ReactComponent };